import { ReactComponent as IconPoint } from "../../../styles/assets/svg/icon_point.svg";

interface buttonProps {
  id: string;
  onRowClick?: (id: string) => void;
  totalPoint: string | number;
}

export const HealthPointBox = ({ id, onRowClick, totalPoint }: buttonProps) => {
  return (
    <button
      style={{
        width: "100%",
        padding: 16,
        background: "white",
        boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
        borderRadius: 16,
        justifyContent: "space-between",
        alignItems: "center",
        display: "flex",
        fontWeight: "700",
        color: "var(--neutral-700, #404040)",
        border: "none",
        cursor: "pointer",
      }}
      onClick={() => onRowClick?.(id)}
    >
      <div
        style={{
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
          fontSize: 16,
          lineHeight: "24px",
        }}
      >
        건강 포인트
      </div>
      <div
        style={{
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 4,
          display: "flex",
        }}
      >
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            fontSize: 20,
            lineHeight: "28px",
          }}
        >
          {totalPoint}
        </div>
        <div style={{ width: 24, height: 24, position: "relative" }}>
          <IconPoint />
        </div>
      </div>
    </button>
  );
};
